import { render, staticRenderFns } from "./ElementCard.vue?vue&type=template&id=391c5019&scoped=true"
import script from "./ElementCard.vue?vue&type=script&lang=ts"
export * from "./ElementCard.vue?vue&type=script&lang=ts"
import style0 from "./ElementCard.vue?vue&type=style&index=0&id=391c5019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c5019",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCheckbox,VImg,VTooltip})
